export default {
    methods: {
        isArtworkObsolete(artwork = this.artwork) {
            var layouts = ["L9", "TT"];
            return artwork.type == "aria" && (
            (artwork.format == "single" && layouts.includes(artwork.layout)) ||
            (["double", "vdouble"].includes(artwork.format) && (layouts.includes(artwork.layout) || layouts.includes(artwork.rightLayout))) ||
            (artwork.format == "triple" && (layouts.includes(artwork.layout) || layouts.includes(artwork.tripleRightLayout)))
            )
        }
    }
  };